import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';

const aspectRatio = 495 / 645; // Height / width

export const mainContainerCss = css({
  [MediaQueries.lgAndUp]: {
    position: 'static',
  },
});

export const containerMarginCss = css({
  marginTop: 120,
  [MediaQueries.lgAndUp]: {
    margin: '235px 0 170px',
  },
});

export const thankyouHeadlineCss = css(typography.effra40, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  marginTop: 90,
  position: 'relative',
  wordBreak: 'break-all',
  [MediaQueries.mdAndUp]: {
    ...typography.effra69,
    fontWeight: fontWeights.medium,
    marginTop: 50,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 170,
  },
});

export const imageColumnCss = css({
  [MediaQueries.lgAndUp]: {
    position: 'static',
  },
});

export const thankYouImageContainerCss = css({
  marginTop: 50,
  lineHeight: 0,
  marginRight: -Edges[VIEWPORTS.sm],
  [MediaQueries.mdAndUp]: {
    marginRight: -Edges[VIEWPORTS.md],
    paddingBottom: `${aspectRatio * 100}%`,
    overflow: 'hidden',
  },
  [MediaQueries.lgAndUp]: {
    marginRight: 0,
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: 0,
    paddingBottom: 0,
    maxWidth: 480,
  },
  [MediaQueries.xl]: {
    maxWidth: 567,
  },
});

export const thankYouPictureCss = css({
  display: 'block',
  position: 'relative',
});

export const thankYouImageCss = css({
  width: '100%',
  [MediaQueries.mdAndUp]: {
    position: 'absolute',
  },
  [MediaQueries.lgAndUp]: {
    position: 'relative',
  },
});

export const buttonCss = css(typography.effra14, {
  letterSpacing: 1.6,
  maxWidth: 210,
  width: '100%',
  wordBreak: 'break-all',
  [MediaQueries.mdAndUp]: {
    maxWidth: 'initial',
    minWidth: 180,
    width: 'auto',
  },
});
